export default "__VITE_PUBLIC_ASSET__8ed3fdeb__"